module.exports = __webpack_public_path__ + "img/1200-mk5-fair.18381728.png";